import React, { Component } from "react";

class AboutPage extends Component {
  componentWillMount = () => {
    this.props.setAppDefault();
  };
  componentDidMount = () => {
    window.scrollTo(-100, -100)
  }
  render() {
    return (
      <div
        style={{
          display:
            this.props.appState.currentPage === "about" ? "block" : "none",
        }}
      >
        <div className="flex-container">
          <h1>About Page</h1>
          <p className="ml-5 mr-5">
            SPIRE Lab (<a href="https://spire.ee.iisc.ac.in/spire/" target="_blank"
              rel="noopener noreferrer">https://spire.ee.iisc.ac.in/spire/</a>) at Indian Institute of Science (IISc),
              Bangalore works on exciting research areas including speech production, speech recognition, synthesis, and
              several scientific questions related to speech signal processing & its application to healthcare and language
              learning. Swaragender (Swara + age + gender) is a project where we plan to do research on speech from all ages
              and genders. Initially, we plan to carry out research on voice/speech recordings from children at preschool, school,
              adolescent stages, which are less explored in traditional speech research. We request you to voluntarily contribute
              5-10 minutes of your voice/speech recordings for this project through the following link: <a href="https://spirelab-agender.web.app/" target="_blank"
              rel="noopener noreferrer">https://spirelab-agender.web.app/</a>
          </p>
          <p className="ml-5 mr-5">
            Your voice/speech contribution will only be used for academic research purposes only and no commercial development
            will be carried out of your contributions. Details, provided by you, will be kept confidential.
          </p>
          <p className="ml-5 mr-5">
            You can know more about the project by visiting our page (<a href="https://spire.ee.iisc.ac.in/spire/swaragender.php" target="_blank"
              rel="noopener noreferrer">https://spire.ee.iisc.ac.in/spire/swaragender.php</a>).
              Please spread this message to all your friends, family members, and relatives. We thank you in advance for your support in doing speech research.
          </p>
        </div>
      </div>
    );
  }
}

export default AboutPage;
